import React from 'react';
import Stack from '@mui/material/Stack';
import type { SxProps, Theme } from '@mui/material';

interface IconTextRowProps {
    icon: React.ReactElement<{ sx?: SxProps<Theme> }>;
    children: React.ReactNode;
    iconColor?: string;
}

export const IconTextRow = ({ icon, children, iconColor }: IconTextRowProps) => {
    const renderedIcon = iconColor
        ? React.cloneElement(icon, { sx: { color: iconColor } })
        : icon;

    return (
        <Stack alignItems="center" direction="row" gap={2}>
            {renderedIcon}
            {children}
        </Stack>
    );
};
